/* Automatic-discount display for the parts of the theme that are drawn by
   JavaScript: the live search results and the wishlist (page and drawer).
   Rules come from window.eePromo (set in layout/theme.liquid from Theme
   settings > Automatic discounts display). A rule can target product handles
   and/or collections; the highest active percentage wins. Display only: the
   real discounts are applied by Shopify at checkout. */
(function () {
  "use strict";
  var cfg = window.eePromo;
  if (!cfg || !cfg.rules || !cfg.rules.length) return;

  var rules = cfg.rules.filter(function (r) {
    return r && r.pct > 0 &&
      ((r.handles && r.handles.length) || (r.collections && r.collections.length));
  });
  if (!rules.length) return;

  var colMap = {};
  var CACHE_KEY = "ee-promo-cols";
  var TTL = 60 * 60 * 1000;

  function active(r) { return !r.end || Date.now() / 1000 < r.end; }

  function pctFor(handle) {
    var best = 0;
    rules.forEach(function (r) {
      if (r.pct <= best || !active(r)) return;
      var hit = r.handles.indexOf(handle) !== -1;
      for (var i = 0; !hit && i < r.collections.length; i++) {
        var list = colMap[r.collections[i]];
        if (list && list.indexOf(handle) !== -1) hit = true;
      }
      if (hit) best = r.pct;
    });
    return best;
  }

  function neededCollections() {
    var out = [];
    rules.forEach(function (r) {
      if (!active(r)) return;
      r.collections.forEach(function (c) { if (out.indexOf(c) === -1) out.push(c); });
    });
    return out;
  }

  /* Which products are in a discounted collection is not known to the
     search/wishlist JSON, so the collection product lists are fetched once and
     cached for an hour. Until they arrive, only product-handle rules apply. */
  function loadCollections(done) {
    var need = neededCollections();
    if (!need.length) return done();
    try {
      var cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
      if (cached && Date.now() - cached.t < TTL && need.every(function (c) { return cached.d[c]; })) {
        colMap = cached.d;
        return done();
      }
    } catch (e) {}
    var pending = need.length;
    var failed = false;
    need.forEach(function (c) {
      fetch("/collections/" + encodeURIComponent(c) + "/products.json?limit=250")
        .then(function (r) { if (!r.ok) throw new Error("bad"); return r.json(); })
        .then(function (d) { colMap[c] = (d.products || []).map(function (p) { return p.handle; }); })
        .catch(function () { failed = true; })
        .then(function () {
          pending -= 1;
          if (pending > 0) return;
          if (!failed) {
            try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), d: colMap })); } catch (e) {}
          }
          done();
        });
    });
  }

  function handleOf(box) {
    var a = box.matches("a") ? box : box.querySelector('a[href*="/products/"]');
    if (!a) return "";
    var m = /\/products\/([^\/?#]+)/.exec(a.getAttribute("href") || "");
    if (!m) return "";
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function decorate(root) {
    root.querySelectorAll(".ee-price").forEach(function (price) {
      if (price.getAttribute("data-ee-promo-done")) return;
      if (price.querySelector(".ee-price__sale, .ee-price__was")) return;
      var box = price.closest(".ee-card, .ee-wish-row");
      if (!box) return;
      var pct = pctFor(handleOf(box));
      if (!pct) return;
      var text = (price.textContent || "").trim();
      var p = /^(\D*?)(\d[\d,]*(?:\.\d+)?)(.*)$/.exec(text);
      if (!p) return;
      var cents = Math.round(parseFloat(p[2].replace(/,/g, "")) * 100);
      if (!isFinite(cents)) return;
      var now = Math.round(cents * (100 - pct) / 100);
      var sale = document.createElement("span");
      sale.className = "ee-price__sale";
      sale.textContent = p[1] + (now / 100).toFixed(2) + p[3];
      var was = document.createElement("span");
      was.className = "ee-price__was";
      was.textContent = text;
      price.textContent = "";
      price.appendChild(sale);
      price.appendChild(was);
      price.setAttribute("data-ee-promo-done", "1");
    });
  }

  function init() {
    var roots = document.querySelectorAll(
      "[data-ee-live-results], [data-ee-wishlist-items], [data-ee-wish-drawer-items]"
    );
    if (!roots.length) return;
    roots.forEach(function (root) {
      if (root.getAttribute("data-ee-promo-bound")) return;
      root.setAttribute("data-ee-promo-bound", "1");
      decorate(root);
      if (window.MutationObserver) {
        new MutationObserver(function () { decorate(root); })
          .observe(root, { childList: true, subtree: true });
      }
    });
    loadCollections(function () {
      roots.forEach(decorate);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();